import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

const SubscriptionRequiredModal = ({ open, onContinue, onCancel }) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Subscription Required</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" sx={{ mb: 2 }}>
          A Smart Lock Subscription is required before connecting smart locks to a property.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          You can continue to manage properties and use the dashboard for free. Subscription is only required when connecting smart lock devices.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="secondary">
          Cancel
        </Button>
        <Button onClick={onContinue} variant="contained">
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubscriptionRequiredModal;

